import { generateMeasuresFromDimensions } from './generate-measures.js';
import { meetingBodyLink, minutesTrackerLink } from './links.js';
import { meetingStatusValueLabels, minutesStatusValueLabels } from './value-labels.js';
const aggregatableDimensions = {
    'minutes_tracker.days_to_minutes_approval': {
        aggregations: ['avg', 'max'],
        label: 'Days to Minutes Approval',
        type: 'number',
    },
};
/**
 * Combination data source: Meetings x Minutes.
 * Minutes completion and approval tracking across meetings. Answers which meetings have
 * pending minutes, average time from meeting to approval, and overall minutes currency.
 */
export const minutesTrackerCube = {
    category: 'Meetings',
    description: 'Minutes completion and approval tracking per meeting with status and turnaround metrics.',
    label: 'Minutes Approval Tracker',
    requiredModule: 'hasRecord',
    measures: {
        'minutes_tracker.count': { label: 'Count', type: 'number' },
        ...generateMeasuresFromDimensions(aggregatableDimensions),
        'minutes_tracker.avg_duration_minutes': { label: 'Avg Duration (Minutes)', type: 'number' },
        'minutes_tracker.sum_agenda_item_count': { label: 'Total Agenda Items', type: 'number' },
    },
    dimensions: {
        ...aggregatableDimensions,
        // Meeting
        'minutes_tracker.agenda_item_count': { label: 'Agenda Item Count', type: 'number' },
        'minutes_tracker.has_minutes': { label: 'Has Minutes', type: 'boolean' },
        'minutes_tracker.status': {
            label: 'Meeting Status',
            type: 'string',
            valueLabels: meetingStatusValueLabels,
        },
        'minutes_tracker.title': { label: 'Meeting Title', link: minutesTrackerLink, type: 'string' },
        // Minutes
        'minutes_tracker.minutes_document_status': {
            label: 'Minutes Status',
            type: 'string',
            valueLabels: minutesStatusValueLabels,
        },
        // Meeting Body
        'meeting_bodies.name': { label: 'Meeting Body', link: meetingBodyLink, type: 'string' },
    },
    timeDimensions: {
        'minutes_tracker.completed_at': { label: 'Meeting Completed At', type: 'date' },
        'minutes_tracker.date': { label: 'Meeting Date', type: 'date' },
        'minutes_tracker.minutes_published_at': { label: 'Minutes Published At', type: 'date' },
    },
};
